import request from '@/plugin/axios';
export function searchTasks(params) {
  return request({
    url: 'admin/task/search',
    method: 'get',
    params: params
  });
}
export function searchTaskLogs(params) {
  return request({
    url: 'admin/task/logs',
    method: 'get',
    params: params
  });
}
export function searchTaskAlarms(params) {
  return request({
    url: 'admin/task/alarms',
    method: 'get',
    params: params
  });
}
export function saveTask(params) {
  return request({
    url: 'admin/task/save',
    method: 'post',
    params: params
  });
}
export function deleteTask(params) {
  return request({
    url: 'admin/task/delete',
    method: 'post',
    params: params
  });
}
export function triggerTask(params) {
  return request({
    url: 'admin/task/trigger',
    method: 'post',
    params: params
  });
}
export function pauseTask(params) {
  return request({
    url: 'admin/task/pause',
    method: 'post',
    params: params
  });
}
export function resumeTask(params) {
  return request({
    url: 'admin/task/resume',
    method: 'post',
    params: params
  });
}
export function deleteMultiTasks(params) {
  return request({
    url: 'game/deleteMutil',
    method: 'post',
    params: params
  });
}